var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetFoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "#E8E9EE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_269_826",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 22,
    width: 40,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 22.6667C42.0667 22.6667 47.1167 26.9834 48.25 32.7334C52.5833 33.0334 56 36.6 56 41C56 45.6 52.2667 49.3334 47.6667 49.3334H26C20.4833 49.3334 16 44.85 16 39.3334C16 34.1834 19.9 29.9334 24.9167 29.4C27 25.4 31.1833 22.6667 36 22.6667ZM39.3333 44.3334V37.6667H44.3333L36.6 29.9167C36.2667 29.5834 35.75 29.5834 35.4167 29.9167L27.6667 37.6667H32.6667V44.3334H39.3333Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_269_826)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 40,
    height: 40,
    fill: "#000E4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetFoto);
export default __webpack_public_path__ + "static/media/setFoto.1c9dbb0980b6b5c622b93a96a7dffd94.svg";
export { ForwardRef as ReactComponent };